'use client';

import { useState, Children, isValidElement, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

type Filter = 'all' | 'levi' | 'yllas';

export default function CabinsFilterBar({
  children,
  allLabel = 'All',
}: {
  children: ReactNode;
  allLabel?: string;
}) {
  const [activeFilter, setActiveFilter] = useState<Filter>('all');

  const filters: { label: string; value: Filter }[] = [
    { label: allLabel, value: 'all' },
    { label: 'Levi', value: 'levi' },
    { label: 'Ylläs', value: 'yllas' },
  ];

  // Filter children based on their data-resort prop
  const filteredChildren = Children.toArray(children).filter((child) => {
    if (activeFilter === 'all') return true;
    if (isValidElement(child)) {
      const props = child.props as { 'data-resort'?: string };
      return props['data-resort'] === activeFilter;
    }
    return true;
  });

  return (
    <>
      <div className="flex items-center justify-center gap-3 mb-12">
        {filters.map((f) => (
          <button
            key={f.value}
            onClick={() => setActiveFilter(f.value)}
            className={cn(
              'px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200',
              activeFilter === f.value
                ? 'bg-[#9B7B3A] text-slate-950 shadow-md'
                : 'bg-slate-200 text-slate-600 hover:bg-slate-300'
            )}
          >
            {f.label}
          </button>
        ))}
      </div>
      <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {filteredChildren}
      </div>
    </>
  );
}
